export default __webpack_public_path__ + "static/media/agt.79f355c4.png";